export default "__VITE_ASSET__BHt9vr9Q__"